/* KASTENKISTE · Musik-Leiste (oben) + unterbrechungsfreie Navigation
   Der Song startet NUR auf Klick des Besuchers (nie automatisch) und läuft beim
   Seitenwechsel weiter: interne Links werden abgefangen, die neue Seite per fetch
   geladen und nur der Inhalt (#kk-inhalt) ausgetauscht – das <audio> in der oberen
   Leiste bleibt bestehen und spielt nahtlos weiter.
   Anker-Links (/#meinweg, /#finder): auf derselben Seite sanftes Scrollen mit
   Header-Versatz + Mobil-Menü zu; von einer Unterseite Wechsel zur Startseite und
   danach zum Anker scrollen (statt nach oben). */
(function(){
  var audio=document.getElementById('kk-song');
  if(!audio) return;
  var bar=document.getElementById('kk-topbar');
  var playBtn=bar?bar.querySelector('[data-kk-play]'):null;
  var vol=bar?bar.querySelector('[data-kk-vol]'):null;
  var hint=bar?bar.querySelector('[data-kk-hint]'):null;

  /* Nie automatisch starten */
  audio.autoplay=false;
  try{ audio.removeAttribute('autoplay'); }catch(e){}
  if(!audio.paused){ try{ audio.pause(); }catch(e){} }

  /* Lautstärke wiederherstellen (Default 80 %) */
  try{
    var gv=parseFloat(localStorage.getItem('kk_vol'));
    if(!isFinite(gv)) gv=80;
    gv=Math.max(0,Math.min(100,gv));
    audio.volume=gv/100;
    if(vol) vol.value=gv;
  }catch(e){ audio.volume=0.8; }

  function setzeZustand(){
    var an=!audio.paused;
    if(bar) bar.classList.toggle('spielt',an);
    if(playBtn){ playBtn.innerHTML=an?'&#10074;&#10074;':'&#9654;'; playBtn.setAttribute('aria-label',an?'Musik pausieren':'Musik abspielen'); }
  }
  if(playBtn){
    playBtn.addEventListener('click',function(){
      if(audio.paused){ audio.play().catch(function(){}); } else { audio.pause(); }
    });
  }
  if(vol){
    vol.addEventListener('input',function(){
      var vv=parseFloat(vol.value); if(!isFinite(vv))vv=0;
      audio.volume=Math.max(0,Math.min(1,vv/100));
      try{ localStorage.setItem('kk_vol',String(vv)); }catch(e){}
    });
  }
  audio.addEventListener('play',setzeZustand);
  audio.addEventListener('pause',setzeZustand);
  setzeZustand();

  /* Erstbesuch: einmal kurz auf den Song aufmerksam machen (kein Autoplay!) */
  var designMode=(window.Shopify&&Shopify.designMode);
  if(hint && playBtn && !designMode){
    var schonGesehen=false;
    try{ schonGesehen=(Date.now()-(parseInt(localStorage.getItem('kk_song_hint'),10)||0))<7*86400000; }catch(e){}
    if(!schonGesehen){
      setTimeout(function(){
        if(!audio.paused) return;                 // spielt schon → kein Hinweis nötig
        hint.classList.add('zeigt');
        playBtn.classList.add('wink');
        function weg(){ hint.classList.remove('zeigt'); playBtn.classList.remove('wink'); try{ localStorage.setItem('kk_song_hint',String(Date.now())); }catch(e){} }
        var t=setTimeout(weg,6500);
        playBtn.addEventListener('click',function(){ clearTimeout(t); weg(); },{once:true});
        document.addEventListener('click',function(){ clearTimeout(t); weg(); },{once:true});
      },1300);
    }
  }

  /* Abspielposition über harte Neuladungen retten (Fallback) – nur fortsetzen, nie automatisch starten */
  try{
    var merk=JSON.parse(sessionStorage.getItem('kk_song_stand')||'null');
    if(merk && merk.src===audio.currentSrc){ audio.currentTime=merk.t||0; }
    setInterval(function(){ if(!audio.paused){ sessionStorage.setItem('kk_song_stand',
      JSON.stringify({src:audio.currentSrc,t:audio.currentTime})); } },1000);
  }catch(e){}

  /* ── Seitenwechsel ohne Neuladen: Song läuft ununterbrochen weiter ── */
  if(window.Shopify && Shopify.designMode) return;           // Theme-Editor: normal lassen
  var TABU=/^\/(cart|checkout|account|challenge|password|admin|apps)/;

  function tauschbar(url){
    if(url.origin!==location.origin) return false;
    if(TABU.test(url.pathname)) return false;
    if(/\.(pdf|zip|jpg|jpeg|png|webp|mp3|mp4)$/i.test(url.pathname)) return false;
    return true;
  }

  /* ── Anker-Helfer (Header-Versatz, Ziel per data-anker oder id) ── */
  function stickyH(el){ if(!el)return 0; var p=(window.getComputedStyle?getComputedStyle(el).position:''); return (p==='fixed'||p==='sticky')?el.getBoundingClientRect().height:0; }
  function headerH(){ return stickyH(document.querySelector('.kk-topbar')) + stickyH(document.querySelector('.kk-head')); }
  function ankerZiel(name){ return document.querySelector('[data-anker="'+name+'"]') || document.getElementById(name); }
  function ankerHin(name){
    var el=ankerZiel(name); if(!el) return false;
    var y=el.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop)-headerH()-12;
    if(y<0)y=0;
    try{ window.scrollTo({top:y,behavior:'smooth'}); }catch(e){ window.scrollTo(0,y); }
    return true;
  }
  function menuZu(){
    var nav=document.querySelector('[data-kk-nav]');
    if(nav){ nav.classList.remove('offen','open','aktiv');
      var b=document.querySelector('[data-kk-burger]'); if(b)b.setAttribute('aria-expanded','false'); }
    document.documentElement.classList.remove('nav-offen');
    if(document.body)document.body.classList.remove('nav-offen','menu-open');
  }

  function fuehreScriptsAus(main){
    main.querySelectorAll('script').forEach(function(alt){
      var s=document.createElement('script');
      for(var i=0;i<alt.attributes.length;i++) s.setAttribute(alt.attributes[i].name,alt.attributes[i].value);
      if(!alt.src) s.textContent=alt.textContent;
      alt.replaceWith(s);
    });
  }

  function lade(url, push, name){
    fetch(url.href,{headers:{'X-Requested-With':'kk-spa'}}).then(function(r){
      if(!r.ok) throw 0; return r.text();
    }).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var neu=doc.getElementById('kk-inhalt');
      var alt=document.getElementById('kk-inhalt');
      if(!neu||!alt){ location.href=url.href; return; }
      alt.replaceWith(neu);
      fuehreScriptsAus(neu);
      document.title=doc.title;
      var kopfNeu=doc.querySelector('.kk-head'), kopfAlt=document.querySelector('.kk-head');
      if(kopfNeu&&kopfAlt){ kopfAlt.querySelector('.kk-nav').innerHTML=kopfNeu.querySelector('.kk-nav').innerHTML; }
      if(push) history.pushState({kk:1},'',url.href);
      document.dispatchEvent(new CustomEvent('kk:seite-gewechselt',{detail:{hash:name||''}}));
      if(name){ if(!ankerHin(name)){ setTimeout(function(){ ankerHin(name); },80); } }
      else { window.scrollTo({top:0}); }
    }).catch(function(){ location.href=url.href; });
  }

  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    var a=e.target.closest('a[href]');
    if(!a||a.target==='_blank'||a.hasAttribute('download')) return;
    var roh=a.getAttribute('href')||'';
    if(roh.charAt(0)==='#') return;                          // reiner Anker → macht kk-anker.js
    var url; try{ url=new URL(a.href,location.href); }catch(_){ return; }
    if(url.origin!==location.origin) return;
    var name=(url.hash&&url.hash.length>1)?decodeURIComponent(url.hash.slice(1)):'';
    var gleicheSeite=(url.pathname===location.pathname && url.search===location.search);

    if(name && gleicheSeite){
      if(ankerHin(name)){
        e.preventDefault(); menuZu();
        try{ if(history.replaceState) history.replaceState(null,'','#'+name); }catch(_){}
      }
      return;
    }
    if(!tauschbar(url)) return;
    e.preventDefault();
    menuZu();
    lade(url,true,name);
  });
  window.addEventListener('popstate',function(){
    var u=new URL(location.href);
    lade(u,false,(u.hash&&u.hash.length>1)?decodeURIComponent(u.hash.slice(1)):'');
  });
})();
